
import GoogleMapsLoader from 'google-maps';
import $ from 'jquery';
import _ from 'underscore';
import Settings from './new/Settings';

const SDK_GOOGLE_MAP = "mapSdk"
const SDK_GOOGLE_MAP_LOADING = "mapSdkReady"

class StaticMap {

  constructor() {

    // GoogleMapsLoader.KEY = 'AIzaSyADMFXVitq-UQJlvdbzOaUVKTxUfBeYuVY';
    GoogleMapsLoader.KEY = 'AIzaSyAu-LHm7xgvaOjO7CTtS8wONGyG4jg3AwM';
    GoogleMapsLoader.LIBRARIES = [];

    this.element = null;
    this.map = null;
  }

  addMap ( element ) {

    this.$element = $(element);

    let latitude = this.$element.data('latitude');
    let longitude = this.$element.data('longitude');
    let zoom = this.$element.data('zoom');

    this.google = google;
    this.settings = new Settings(this.google, '/fletcherliving/images/');
    this.settings.staticMapOptions.center = new this.google.maps.LatLng( latitude, longitude );
    if (zoom) this.settings.staticMapOptions.zoom = zoom;

    this.map = new google.maps.Map( this.$element[0] , this.settings.staticMapOptions );

    let options = {
      position : new this.google.maps.LatLng(latitude, longitude),
      icon     : this.settings.houseMarker
    };

    let marker = new this.google.maps.Marker(options);
    marker.setMap(this.map);
  }

  load( element ) {
    if (typeof google === 'undefined') {
      GoogleMapsLoader.load((google) => {
        this.addMap(element)
      });
    } else {
      this.addMap(element)
    }
  }
}

export { StaticMap as default };
